import React from "react";
import { Icon } from "@dc/react-components";
import { Svg } from "../../../ws10";

function Tile(data) {
  return (
    <div className={data.className}>
      <div className="tiles__image">
        <div
          className="background__image lazyloaded"
          style={{
            backgroundImage: `url(${data.imageUrl})`
          }}></div>
      </div>
      <h4 className="heading heading--4 tiles__title">{data.tileInfo}</h4>
      <a className=" heading heading--6 tiles__link">
        <span className="tiles__chevron--text ">
          Learn more
          <Icon Source={Svg.ChevronRight} className="icon--extra-small chevron__icon" />
        </span>
      </a>
    </div>
  );
}

export default Tile;
